import styled from 'styled-components';

import { IconLocked } from 'components/icons/locked';

export const LockedOfferContainer = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  margin: auto;
  inset-block-start: 0;
  inset-block-end: 0;
  inset-inline-start: 0;
  inset-inline-end: 0;
  border-radius: 0;
  z-index: ${Styles.zIndex.top};
  align-items: center;
  justify-content: center;
  display: flex;
  background-color: rgba(0, 0, 0, 0.5);
`;

export const StyledLock = styled(IconLocked)`
  width: 2.5rem;
  height: 2.5rem;
  inset-block-start: 50%;
  inset-inline-start: 50%;
  border-radius: 2px;
`;
